"use strict";

/* Controllers */

angular
    .module("BannerFlowApp")
    .controller(
        "MainController",
        function MainController(
            $http,
            $stateParams,
            $state,
            $scope,
            $location,
            $rootScope,
            AuthInfo,
            Global,
            Utils
        ) {
            var user = $rootScope.bannerFlowUser;

            if (!user) {
                return;
            }

            $rootScope.allAccounts = user.accounts;

            if (user.accounts.length > 0) {
                var usr = user.user;

                var currAccount = _.find(user.accounts, function (acc) {
                    return acc.current;
                });
                if (!currAccount) {
                    $state.go("otherwise");
                    return;
                }

                if (currAccount.brands.length === 0) {
                    $state.go("otherwise");
                    return;
                }

                usr.currentAccount = currAccount;

                var currBrand = _.find(currAccount.brands, function (br) {
                    return br.current;
                });
                if (!currBrand) {
                    $state.go("otherwise");
                    return;
                }

                usr.currentBrand = currBrand;

                //Finding the first BannerFlow priceplan and set it to 'plan'
                // TODO: On login, currentAccount (and brand) should be the one used just before login
                usr.currentAccount.plan = null;
                //usr.currentAccount.owner = false;
                for (var i = 0; i < usr.currentAccount.plans.length; i++) {
                    if (usr.currentAccount.plans[i].planCode.substr(0, 3) === "bf-") {
                        usr.currentAccount.plan = usr.currentAccount.plans[i];
                        break;
                    }
                }

                var today = new Date();
                var periodEnds = new Date(usr.currentAccount.plan.periodEnds);
                usr.currentAccount.plan.daysLeft = Date.daysBetween(today, periodEnds);

                AuthInfo.LoggedInUser.tours = {};
                AuthInfo.LoggedInUser = usr;
                AuthInfo.LoggedInUser.isEmployee = usr.employee === 3;
                AuthInfo.LoggedInUser.accounts = user.accounts;
                $rootScope.allBrands = new Array();

                // If the user has demo analytics data feture, fake impressions on current brand
                if (AuthInfo.HasFeatures([$rootScope.FEATURE_ANALYTICS_DEMO_DATA])) {
                    AuthInfo.LoggedInUser.currentBrand.impressionsLastWeek = Math.round(
                        Math.random() * 100000000 + 50000000
                    );
                }

                for (var i = 0; i < user.accounts.length; i++) {
                    for (var j = 0; j < user.accounts[i].brands.length; j++) {
                        var brand = user.accounts[i].brands[j];
                        brand.accountSlug = user.accounts[i].slug;
                        $rootScope.allBrands.push(brand);
                    }
                }

                $rootScope.allBrands = _.sortBy($rootScope.allBrands, function (b) {
                    return b.name.toLowerCase();
                });

                $rootScope.isLoaded = true;

                if (
                    $location.$$path == "//" ||
                    $stateParams.rootBrandId === "" ||
                    $location.$$path ===
                        "/{0}/{1}".format(
                            AuthInfo.LoggedInUser.currentAccount.slug,
                            AuthInfo.LoggedInUser.currentBrand.slug
                        )
                ) {
                    Utils.GoHome();
                    $rootScope.isLoaded = true;
                } else {
                    $rootScope.isLoaded = true;
                }
            } else {
                $state.go("otherwise");
            }

            $scope.loader = Global.Loader;

            $rootScope.goToHomeAccount = function () {
                var homeAccount = $scope.getOwnerAccount($rootScope.allAccounts);
                window.location = "/{0}/{1}/Settings/Account".format(
                    homeAccount.slug,
                    homeAccount.brands[0].slug
                );
            };

            $rootScope.resendConfirmationLink = function () {
                $http({
                    method: "POST",
                    url: "/api/v1/a/{0}/account/resendactivation".format(
                        AuthInfo.LoggedInUser.currentAccount.slug
                    )
                }).success(function () {
                    alert("A new activation email has been sent to your email");
                });
            };

            $rootScope.preventPropagation = function ($event) {
                $event.stopPropagation();
                return true;
            };

            $rootScope.gotoCampaigns = function () {
                if ($rootScope.allBrands.length < 2) $state.go("root.campaigns");
            };
        }
    );
